export default __webpack_public_path__ + "static/media/Background_00278.52092d2e.png";